<div class="p-4 bg-white rounded-lg shadow-lg w-full">
  <h4 class="font-semibold text-gray-800 mb-4 text-center">Select Date</h4>

  <!-- Calendar -->
  <div class="flex justify-center">
    <mat-calendar [maxDate]="data.maxDate" [minDate]="data.minDate" [selected]="selectedDate"
      (selectedChange)="onDaySelected($event)" (viewChanged)="onViewChanged($event)"
      class="bg-gray-100 p-2 rounded-lg w-72"></mat-calendar>
  </div>


  <!-- Actions -->
  <div class="flex justify-end mt-6 space-x-2">
    <button mat-flat-button class="px-3 py-1 transition text-sm cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
    <button [disabled]="!isValidDate()" mat-flat-button color="primary" class="px-3 py-1 transition text-sm save-btn"
      (click)="confirmDateTime()">
      OK
    </button>
  </div>
</div>
